editSchoolEntity.$inject = ['graph']

export default function editSchoolEntity(graph) {
  return {
    restrict: 'EA',
    scope: {
      refSchool: '=school',
      onSchoolUpdated: '&'
    },
    template: require('./_editSchoolEntity.html'),
    link: function(scope) {
      scope.$watch('refSchool', function(s) {
        init()
      })

      function init() {
        if (scope.refSchool) {
          scope.schoolEditInfo = { name: scope.refSchool.name }
        }
      }

      // error handling
      scope.errorMessage = ''
      scope.showError = false

      scope.savingSchool = false
      scope.saveSchool = function(data) {
        scope.savingSchool = true
        scope.showError = false
        graph.updateSchool(scope.refSchool.uuid, data).then(
          function(updatedSchool) {
            scope.onSchoolUpdated({ school: updatedSchool })
            scope.savingSchool = false
          },
          function(reason) {
            scope.errorMessage = 'There was an error saving the school. ' + reason
            scope.showError = true
            scope.savingSchool = false
          }
        )
      }
    }
  }
}
